"use strict";

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }

  return cooked;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importDefault(require("react"));

var styled_1 = __importDefault(require("@emotion/styled"));

var react_2 = require("react");

var ImageEditor_1 = require("./ImageEditor");

var Image_1 = require("./Image");

var Swatch = styled_1.default.button(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  width: 100%;\n  padding: 5px;\n  background: #fff;\n  border: 1px solid grey;\n  border-radius: 4px;\n  display: block;\n  cursor: pointer;\n"], ["\n  width: 100%;\n  padding: 5px;\n  background: #fff;\n  border: 1px solid grey;\n  border-radius: 4px;\n  display: block;\n  cursor: pointer;\n"])));
var PopOver = styled_1.default.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  display: ", ";\n  position: absolute;\n  z-index: 2;\n  width: 100%;\n"], ["\n  display: ", ";\n  position: absolute;\n  z-index: 2;\n  width: 100%;\n"])), function (_a) {
  var isOpen = _a.isOpen;
  return isOpen ? 'block' : 'none';
});
var Cover = styled_1.default.div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  position: fixed;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n"], ["\n  position: fixed;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n"])));
var Dropdown = styled_1.default.div(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  padding: 5px;\n  background: #fff;\n  position: absolute;\n  z-index: 2;\n  width: 100%;\n  min-width: 300px;\n  max-width: 100vw;\n  border: 1px solid grey;\n  border-radius: 4px;\n"], ["\n  padding: 5px;\n  background: #fff;\n  position: absolute;\n  z-index: 2;\n  width: 100%;\n  min-width: 300px;\n  max-width: 100vw;\n  border: 1px solid grey;\n  border-radius: 4px;\n"])));

exports.ImagePicker = function (_a) {
  var value = _a.value,
      onChange = _a.onChange,
      organizationId = _a.organizationId;

  var _b = react_2.useState(false),
      isOpen = _b[0],
      setOpen = _b[1];

  var handleChange = function handleChange(image) {
    onChange(image);
    setOpen(false);
  };

  return react_1.default.createElement(react_1.default.Fragment, null, react_1.default.createElement(Swatch, {
    onClick: function onClick(e) {
      e.preventDefault();
      setOpen(!isOpen);
    }
  }, react_1.default.createElement(Image_1.Image, {
    value: value
  })), react_1.default.createElement(PopOver, {
    isOpen: isOpen
  }, react_1.default.createElement(Cover, {
    onClick: function onClick(e) {
      e.preventDefault();
      setOpen(false);
    }
  }), react_1.default.createElement(Dropdown, null, react_1.default.createElement(ImageEditor_1.ImageEditor, {
    onChange: handleChange,
    organizationId: organizationId
  }))));
};

var templateObject_1, templateObject_2, templateObject_3, templateObject_4;